import React from 'react'

export const iconsKeys = {
  SocialInstagram: 'social-instagram',
  Logo: 'logo',
}

type IconWrapperProps = (fileName: string, width: number, height: number) => JSX.Element

const IconWrapper: IconWrapperProps = (fileName, width, height) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <use xlinkHref={`/icones/spritemap.svg#${fileName}`} />
  </svg>
)

export const icons = {
  [iconsKeys.SocialInstagram]: IconWrapper('social-instagram', 12, 12),
  [iconsKeys.Logo]: IconWrapper('logo', 446, 53),
}

export default icons
